// 셀프 입점 액션(rpc) — 가입·확인 메일 다시 보내기·비밀번호 찾기·비밀번호 정하기·시공사 만들기(user)·반려 재신청·출시 알림.
import type { OrgCreateResult, ReapplyInfoResult, SignupResult } from "@buildpy/core/modules/onboarding/actions";
import type { MonthlySites, PlanInterestNeed, SignupSource, StaffSize, WorkType } from "@buildpy/core/modules/onboarding/types";

import { rpc } from "@/api/client";

export type { OrgCreateResult, ReapplyInfoResult, SignupResult };

export interface SignupForm {
  email: string;
  name: string;
  turnstileToken?: string;
}

export interface OrgCreateForm {
  name: string;
  slug: string;
  tel: string;
  ceo: string;
  ownerName?: string;
  ownerPhone?: string;
  address?: string;
  bizNo?: string;
  licenseNo?: string;
  staffSize?: StaffSize | null;
  workTypes?: WorkType[];
  monthlySites?: MonthlySites | null;
  source?: SignupSource | null;
  agree: { terms: boolean; privacy: boolean };
}

export interface PlanInterestForm {
  needs: PlanInterestNeed[];
  memo?: string;
  name: string;
  email: string;
}

export const selfSignup = (input: SignupForm) => rpc("onboarding/actions/selfSignup", input);

export const resendSignupMail = (email: string) => rpc("onboarding/actions/resendSignupMail", { email });

export const requestPasswordReset = (email: string) => rpc("onboarding/actions/requestPasswordReset", { email });

export const signupStatus = () => rpc("onboarding/actions/signupStatus");

export const setSignupPassword = (input: { password: string; confirm: string }) => rpc("onboarding/actions/setSignupPassword", input);

export const selfCreateOrg = (input: OrgCreateForm) => rpc("onboarding/actions/selfCreateOrg", input);

export const reapplyInfo = () => rpc("onboarding/actions/reapplyInfo");

export const reapplyOrg = (input: Omit<OrgCreateForm, "agree" | "slug">) => rpc("onboarding/actions/reapplyOrg", input);

export const submitPlanInterest = (input: PlanInterestForm) => rpc("onboarding/actions/submitPlanInterest", input);
